import useQuestionnaire from 'hooks/useQuestionnaire';
import { checkSpanishLocale, cn } from 'lib/utils';
import { useMemo, useState } from 'react';
import { useQuestionnaireStore } from 'store/questionnaire';
import QuestionnaireContainer from './components/QuestionnaireContainer';
import { motion } from 'framer-motion';
import Checkmark from 'pages/profile/questionnaire/components/Checkmark';

export default function MedicalCondition() {
  const questionData = useQuestionnaireStore((store) => store.questionData);

  const isSpanish = checkSpanishLocale();

  const { onSubmit, isLoading } = useQuestionnaire();

  const [selectedIndex, setSelectedIndex] = useState(0);

  const englishChoices = JSON.parse(questionData?.eng_choices || '[]');
  const spanishChoices = JSON.parse(questionData?.spanish_choices || '[]');

  const options: { en: string; es: string }[] = useMemo(
    () =>
      englishChoices.map((choice: string, index: number) => ({
        en: choice,
        es: spanishChoices[index],
      })),
    [englishChoices, spanishChoices]
  );
  const buttons = options.map((option) => option?.[isSpanish ? 'es' : 'en']);

  const onContinue = async () => {
    const englishChoice = options[selectedIndex]?.en;
    const spanishChoice = options[selectedIndex]?.es;

    await onSubmit({
      choice_value: JSON.stringify([englishChoice]),
      spanish_choice_value: JSON.stringify([spanishChoice]),
      questionData,
    });
  };

  return (
    <QuestionnaireContainer
      questionData={questionData}
      isLoading={isLoading}
      onContinue={onContinue}
      questionNumber={10}
    >
      <div className='grid grid-cols-2 gap-6'>
        {buttons?.length
          ? buttons.map((option, index) => {
              const isSelected = index === selectedIndex;

              return (
                <motion.div
                  key={option}
                  onClick={() => setSelectedIndex(index)}
                  className={cn(
                    'w-full border-[2px] rounded-2xl px-4 py-2 flex items-center justify-between cursor-pointer text-[#656D76] gap-4',
                    isSelected && 'border-primary text-primary bg-[#E1EBFF]'
                  )}
                  whileTap={{ scale: 0.98 }}
                >
                  <p className='text-sm leading-5'>{option}</p>

                  <Checkmark isSelected={isSelected} />
                </motion.div>
              );
            })
          : []}
      </div>
    </QuestionnaireContainer>
  );
}
